import { Divider, Tabs } from 'antd';
import styled from 'styled-components/macro';

export const StyledDivider = styled(Divider)`
  border-top: 1px solid rgba(0, 0, 0, 0.3);
`;
